var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"twitter-timeline",attrs:{"data-height":"842","href":'https://twitter.com/' + _vm.config.VUE_APP_TWITTER_NAME + '?ref_src=twsrc%5Etfw'}},[_vm._v("Tweets by tartanprotour")]),_vm._v(" "),_c('script',{attrs:{"type":"application/javascript","async":"","src":"https://platform.twitter.com/widgets.js","charset":"utf-8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }